import { render, staticRenderFns } from "./HelpItem.vue?vue&type=template&id=16c7d5c0"
import script from "./HelpItem.vue?vue&type=script&lang=js"
export * from "./HelpItem.vue?vue&type=script&lang=js"
import style0 from "./HelpItem.vue?vue&type=style&index=0&id=16c7d5c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports